import { Box, Button, Heading, HStack, Stack, Text, useColorModeValue, VStack } from "@chakra-ui/react";
import { signOut } from "firebase/auth";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { auth } from "../../../firebase/Firebase";
import { useSubscriptions } from "../../../hooks/billingHooks";
import { apixios } from "../../../lib/axios";
import { createNotification } from "../../../lib/notification";
import useAuthContext from "../../context/AuthContext";


const StripePlan = () => {

  const router = useRouter()
  const {currentShop, currentAuthority} = useAuthContext()
  const {plans, setPlans, planLoading} = useSubscriptions(currentAuthority)
  const isSuccessSubscribe = Boolean(router.query.success)

  useEffect(() => {
    if (isSuccessSubscribe) {
      createNotification('success', 'ご加入ありがとうございます。データの反映には数分かかる場合がございます。')
    }
  }, [isSuccessSubscribe])

  const [currentPriceId, setCurrentPriceId] = useState('')
  const [currentSubscriptionId, setCurrentSubscriptionId] = useState('')
  const minimumId = process.env.NEXT_PUBLIC_MINIMUM_PRICE_ID as string
  const mediumId = process.env.NEXT_PUBLIC_MEDIUM_PRICE_ID as string
  const premiumId = process.env.NEXT_PUBLIC_PREMIUM_PRICE_ID as string

  useEffect(() => {
    if (!plans.length) return
    setCurrentPriceId(plans[0].priceId)
    setCurrentSubscriptionId(plans[0].id)
  }, [plans])

  return (<div className="container mx-auto p-10">
    <Box py={12}>
      <VStack spacing={2} textAlign="center" mb={20}>
        <Heading as="h1" fontSize="4xl">All In One Support Desk</Heading>
        <Text fontSize="lg" color={'gray.500'}>
          日々のお問合せを効率的に
        </Text>
      </VStack>
      <Stack
        direction={{ base: 'column', md: 'row' }}
        textAlign="center"
        justify="center"
        spacing={{ base: 4, lg: 10 }}
        py={10}>
        <PriceWrapper>
          <Box py={3} px={6}>
            <Text fontWeight="500" fontSize="2xl">
              ミニマムプラン
            </Text>
            <HStack justifyContent="center">
              <Text fontSize="5xl" fontWeight="900">
                7980
              </Text>
              <Text fontSize="3xl" fontWeight="600">
                円
              </Text>
              <Text fontSize="3xl" color="gray.500">
                /月
              </Text>
            </HStack>
            <Text fontWeight="500" fontSize="lg" mt={5}>
              5人までのプランです。
            </Text>
          </Box>
          <VStack
            bg={useColorModeValue('gray.50', 'gray.700')}
            py={4}
            borderBottomRadius={'xl'}>
            <Box w="80%" pt={7}>
              { (currentPriceId != minimumId) && <Button
                w="full"
                colorScheme="red"
                variant="outline"
                onClick={() => {
                  if (!currentPriceId) {
                    apixios.post('/api/plans/web/subscribe', {
                      priceId: minimumId
                    }).then((res) => {
                      if (!res.data) {
                        createNotification('error', 'プランの加入に失敗しました。')
                        return
                      }
                      router.push(res.data)
                    }).catch((error) => {
                      createNotification('error', 'プランの加入に失敗しました。')
                      console.error(error);
                    })
                  } else {
                    apixios.post('/api/plans/web/change-plan', {
                      afterPriceId: minimumId,
                      subscriptionId: currentSubscriptionId
                    }).then((res) => {
                      setCurrentPriceId(minimumId)
                      createNotification('success', 'プランが変更されました。来月の更新時に新しい金額で決済されます。')
                    }).catch((error) => {
                      createNotification('error', 'プランの変更に失敗しました。')
                      console.error(error);
                    })
                  }
                }}
              >
                {!!currentPriceId ? "このプランに変更する" : "登録する"}
              </Button> }
              { currentPriceId == minimumId && <Button onClick={() => {
                apixios.post('/api/plans/web/delete-subscription', {
                  subscriptionId: currentSubscriptionId
                }).then((res) => {
                  setCurrentPriceId('')
                  setCurrentSubscriptionId('')
                  createNotification('success', 'プランの登録が解除されました。')
                }).catch((error) => {
                  console.error(error)
                  createNotification('error', 'プランの登録解除に失敗しました。')
                })
              }}>キャンセルする</Button> }
            </Box>
          </VStack>
        </PriceWrapper>

        <PriceWrapper>
          <Box position="relative">
            <Box
              position="absolute"
              top="-16px"
              left="50%"
              style={{ transform: 'translate(-50%)' }}>
              <Text
                textTransform="uppercase"
                bg={useColorModeValue('red.300', 'red.700')}
                px={3}
                py={1}
                color={useColorModeValue('gray.900', 'gray.300')}
                fontSize="sm"
                fontWeight="600"
                rounded="xl">
                大人気!!
              </Text>
            </Box>
            <Box py={3} px={6}>
              <Text fontWeight="500" fontSize="2xl">
                ノーマルプラン
              </Text>
              <HStack justifyContent="center">
                <Text fontSize="5xl" fontWeight="900">
                  14980
                </Text>
                <Text fontSize="3xl" fontWeight="600">
                  円
                </Text>
                <Text fontSize="3xl" color="gray.500">
                  /月
                </Text>
              </HStack>
              <Text fontWeight="500" fontSize="lg" mt={5}>
                10人までのプランです。
              </Text>
            </Box>
            <VStack
              bg={useColorModeValue('gray.50', 'gray.700')}
              py={4}
              borderBottomRadius={'xl'}>
              <Box w="80%" pt={7}>
              { (currentPriceId != mediumId) && <Button
                w="full"
                colorScheme="red"
                onClick={() => {
                  if (!currentPriceId) {
                    apixios.post('/api/plans/web/subscribe', {
                      priceId: mediumId
                    }).then((res) => {
                      if (!res.data) {
                        createNotification('error', 'プランの加入に失敗しました。')
                        return
                      }
                      router.push(res.data)
                    }).catch((error) => {
                      createNotification('error', 'プランの加入に失敗しました。')
                      console.error(error);
                    })
                  } else {
                    apixios.post('/api/plans/web/change-plan', {
                      subscriptionId: currentSubscriptionId,
                      afterPriceId: mediumId
                    }).then((res) => {
                      setCurrentPriceId(mediumId)
                      createNotification('success', 'プランが変更されました。来月の更新時に新しい金額で決済されます。')
                    }).catch((error) => {
                      createNotification('error', 'プランの変更に失敗しました。')
                      console.error(error);
                    })
                  }
                }}
              >
                {!!currentPriceId ? "このプランに変更する" : "登録する"}
              </Button> }
              { currentPriceId == mediumId && <Button onClick={() => {
                apixios.post('/api/plans/web/delete-subscription', {
                  subscriptionId: currentSubscriptionId
                }).then((res) => {
                  setCurrentPriceId('')
                  setCurrentSubscriptionId('')
                  createNotification('success', 'プランの登録が解除されました。')
                }).catch((error) => {
                  console.error(error)
                  createNotification('error', 'プランの登録解除に失敗しました。')
                })
              }}>キャンセルする</Button> }
              </Box>
            </VStack>
          </Box>
        </PriceWrapper>
        <PriceWrapper>
          <Box py={3} px={6}>
            <Text fontWeight="500" fontSize="2xl">
              エンタープライズプラン
            </Text>
            <HStack justifyContent="center">
              <Text fontSize="5xl" fontWeight="900">
                29800
              </Text>
              <Text fontSize="3xl" fontWeight="600">
                円
              </Text>
              <Text fontSize="3xl" color="gray.500">
                /月
              </Text>
            </HStack>
            <Text fontWeight="500" fontSize="lg" mt={5}>
              99人までのプランです。
            </Text>
          </Box>
          <VStack
            bg={useColorModeValue('gray.50', 'gray.700')}
            py={4}
            borderBottomRadius={'xl'}>
            <Box w="80%" pt={7}>
            { (currentPriceId != premiumId) && <Button
                w="full"
                colorScheme="red"
                variant="outline"
                onClick={() => {
                  if (!currentPriceId) {
                    apixios.post('/api/plans/web/subscribe', {
                      priceId: premiumId
                    }).then((res) => {
                      if (!res.data) {
                        createNotification('error', 'プランの加入に失敗しました。')
                        return
                      }
                      router.push(res.data)
                    }).catch((error) => {
                      createNotification('error', 'プランの加入に失敗しました。')
                      console.error(error);
                    })
                  } else {
                    apixios.post('/api/plans/web/change-plan', {
                      afterPriceId: premiumId,
                      subscriptionId: currentSubscriptionId
                    }).then((res) => {
                      setCurrentPriceId(premiumId)
                      createNotification('success', 'プランが変更されました。来月の更新時に新しい金額で決済されます。')
                    }).catch((error) => {
                      createNotification('error', 'プランの変更に失敗しました。')
                      console.error(error);
                    })
                  }
                }}
              >
                {!!currentPriceId ? "このプランに変更する" : "登録する"}
              </Button> }
              { currentPriceId == premiumId && <Button onClick={() => {
                apixios.post('/api/plans/web/delete-subscription', {
                  subscriptionId: currentSubscriptionId
                }).then((res) => {
                  setCurrentPriceId('')
                  setCurrentSubscriptionId('')
                  createNotification('success', 'プランの登録が解除されました。')
                }).catch((error) => {
                  console.error(error)
                  createNotification('error', 'プランの登録解除に失敗しました。')
                })
              }}>キャンセルする</Button> }
            </Box>
          </VStack>
        </PriceWrapper>
      </Stack>
    </Box>
    <Button onClick={() => {
        signOut(auth).then(() => {
          router.push('/auth/login')
        }).catch((error) => {
          createNotification('error', 'サインアウトに失敗しました')
        })
      }}>ログアウト</Button>
  </div>)
}


const PriceWrapper = ({ children }) => {
  return (
    <Box
      mb={4}
      shadow="base"
      borderWidth="1px"
      alignSelf={{ base: 'center', lg: 'flex-start' }}
      borderColor={useColorModeValue('gray.200', 'gray.500')}
      borderRadius={'xl'}>
      {children}
    </Box>
  );
}

export default StripePlan;